import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20background%20with%20gentle%20flowing%20shapes%20in%20warm%20coral%20and%20cream%20tones%2C%20modern%20minimalist%20design%2C%20calm%20nurturing%20atmosphere%2C%20educational%20and%20supportive%20visual%20language%2C%20soft%20ambient%20light&width=1800&height=800&seq=cta-bg-2025&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-primary-500/90" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4">
          开启科学性教育之旅
        </h2>
        <p className="text-base md:text-lg text-background-50/85 mb-8 leading-relaxed">
          无论是青少年、家长还是教师，都能在这里找到适合的性教育资源。
          科学的性教育，是送给孩子最好的成长礼物。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/puberty"
            className="px-8 py-3.5 bg-background-50 hover:bg-background-100 text-primary-600 font-medium text-sm rounded-lg transition-all duration-300 hover:scale-[1.02] whitespace-nowrap"
          >
            开始免费学习
            <i className="ri-arrow-right-line ml-2" />
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-primary-600/40 hover:bg-primary-600/60 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg transition-all duration-300 hover:scale-[1.02] whitespace-nowrap"
          >
            了解我们的故事
          </Link>
        </div>
      </div>
    </section>
  );
}